/**
 * Builds a Google OAuth 2.0 authorization URL with explicit parameters.
 *
 * This bypasses @react-oauth/google's useGoogleLogin which doesn't reliably
 * include custom scopes (gmail.modify), prompt=consent, or access_type=offline
 * when using ux_mode:'redirect'.
 */
export const buildGoogleAuthUrl = ({ state, redirectUri, scope, hint }) => {
  const params = new URLSearchParams({
    client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    redirect_uri: redirectUri,
    response_type: 'code',
    scope: scope,
    access_type: 'offline',
    prompt: 'consent',
    state: state,
  });
  if (hint) params.set('login_hint', hint);
  return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
};
